import { lazy } from "react";

const LicenceDealPage = lazy(() => import("./LicenceDealPage"));

export { LicenceDealPage };
